import { Heading, Paragraph } from '@graftcode/design-system'

import type { GlossaryTerm } from '@/modules/glossary/glossary.interface'

import { GLOSSARY_TEST_IDS } from '../../glossary.const'

import styles from './GlossaryTermCard.module.scss'

type GlossaryTermCardProps = {
  term: GlossaryTerm
}

export function GlossaryTermCard({ term }: GlossaryTermCardProps) {
  return (
    <div id={term.id} className={styles.card} data-testid={GLOSSARY_TEST_IDS.termCard}>
      <div className={styles.content}>
        <Heading className={styles.term} type="h2">
          {term.term}
        </Heading>
        <Paragraph className={styles.definition}>{term.definition}</Paragraph>
      </div>
    </div>
  )
}
